import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProductDetailAttribute from '../ProductDetailAttribute/ProductDetailAttribute';
import { PriceConvert } from '../../../../../UI/Price/Price';

export default function AttributeDropDown(props) {
  const attrValues = props.getAttributeValues(props.attribute.values);
  const additionalSizes =
    props.contentData.additionalSizes?.filter((currentSize) => currentSize.productURL !== '') ?? [];

  useEffect(() => {
    if (props.passedAppFunctions.siteFormat !== 'mobile') {
      let hasOneOptionClass = document.getElementsByClassName('one-option');
      if (hasOneOptionClass.length > 0) {
        showPricePoints = true;
      }
    }
  }, []);

  //Quickview Pricing
  //Refer to Shared Product Detail page, initializeStateObjects function where setting product page type for showing dropdown price points
  let curPriceVals = [];
  let showPricePoints = false;
  let isOneAttr = false;
  let oneAttrSamePrice = false;

  //Price points are only shown in dropdowns on QuickView, Bundle and Outfit pages
  if (props.isQuickView || props.isBundle) {
    let QV_productPageType;

    //Is this a SKU that has only 1 Attribute? Let's check to see if all attributes have the same price (do NOT show if the prices are equal)
    if (props.passedFunctions.parentState.productPageType.includes('One Attribute')) {
      isOneAttr = true;
      curPriceVals = props.oneAttrPricing;
      const allEqual = (arr) => arr.every((val) => val.price === arr[0].price);
      oneAttrSamePrice = allEqual(curPriceVals);
    } else {
      //If it's a SKU with 2+ attributes, build a prices array
      Object.keys(props.priceForDisplay).map((attr) => {
        if (attr === props.attribute.name) {
          Object.values(props.priceForDisplay?.[props.attribute.name]).map((attrStr) => {
            curPriceVals.push(attrStr);
          });
        }
      });
    }

    //Check for SKUs 2 Attributes ONLY with 1 attribute having one-option for value
    if (Object.keys(props.currentAttributeState).length == 2 && !props.isBundle) {
      let hasOneOptionClass = document?.querySelector('.one-option');
      let hasOneOptAttr = false;
      if (hasOneOptionClass) {
        let oneOptAttrName = hasOneOptionClass.parentElement.className.replace('form-group ', '');
        hasOneOptAttr = true;
        if (!oneAttrSamePrice) {
          if (props.attribute.name !== oneOptAttrName && hasOneOptAttr) {
            showPricePoints = true;
          }
        }
      }
    }

    //Check for SKUS that have 2+ attributes but one of them has a value of ONE SIZE
    Object.values(props.currentAttributeState).map((attr) => {
      if (attr.attrName === 'Size' && attr.selectedValue === 'One Size') {
        QV_productPageType = 'OneSize';
      }
    });

    //SKUS that have One Attribute and they each sku has different prices, show prices ALWAYS
    if (isOneAttr && !oneAttrSamePrice) {
      showPricePoints = true;
    }

    //SKUS with 2+ attributes where one of the attributes has One Size as a value need to ALWAYS show price points in DropDown
    if (QV_productPageType === 'OneSize') {
      showPricePoints = true;
    }

    //SKUS that have 2+ attributes and the DropDown Attr Name is not what the user just selected, show Prices of the other attrs not selected
    if (props.passedFunctions.parentState.curSelectedAttr !== props.attribute.name && !isOneAttr) {
      showPricePoints = true;
    }
  }
  //End of Quickview Pricing

  //Does this Product only have 1 SKU - let's get its value
  if (attrValues.length === 1) {
    props.currentAttributeState[props.attribute.name].selectedValue = attrValues[0];
  }

  //ProductDetailAttribute (parent component) builds all available values for the skus - this function is called when building the JSX in the render to determine classes of available or not-available, disabled/enabled
  const isAvailable = (attrVal) => {
    if (props.availableValues.length > 0) {
      return props.availableValues.includes(attrVal);
    } else {
      return true;
    }
  };

  const findAttrId = (attrName) => {
    const attrObj = props.contentData.skus[0].definingAttributes.find((a) => a.name === attrName);
    return attrObj?.id;
  };

  return (
    <>
      <div className={`form-group ${props.attribute.name}`}>
        <div className='productDisplay__div--labelWrapper'>
          <label className='label'>{props.attribute.name}</label>
          {props.attribute.name == 'Size' &&
          props.contentData.sizeChartName &&
          ((props.passedAppFunctions.siteFormat == 'desktop' && props.isQuickview) || !props.isQuickview) ? (
            <>
              <button className='productDisplay__span--sizeChart' type='button' onClick={props.openSizeChart}>
                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 53.48 26.78' width='14'>
                  <title>size chart</title>
                  <g data-name='Layer 2'>
                    <g data-name='Layer 1'>
                      <path d='M0,0V26.78H53.48V0ZM51.48,24.78H2V2h9.14v8.07h2V2h12.6V15.12h2V2H40.33v8.07h2V2h9.15Z' />
                    </g>
                  </g>
                </svg>
                Size Chart
                <span className='sr-only'>Opens a simulated dialog</span>
              </button>
            </>
          ) : (
            ''
          )}
        </div>
        {attrValues.length > 1 ? (
          <>
            <select
              id={props.attribute.name + '__' + props.contentData.partNumber}
              className='attrSelect form-control'
              onChange={props.changeAttributeState}
              name={props.attribute.name}
              value={props.passedFunctions.parentState.currentAttributeState[props.attribute.name].selectedValue || ''}
              data-attrid={findAttrId(props.attribute.name)}
              data-attrtype={props.attribute.name + 'ID'}
              aria-describedby={props.attribute.hasError ? 'invalidComboContainer' : ''}
            >
              {!props.selectedAttributeValue && (
                <option value='' disabled>
                  {props.attribute.name}
                </option>
              )}
              {props.selectedAttributeValue && (
                <option value='' disabled>
                  {props.attribute.name}
                </option>
              )}

              {attrValues.map((attrValue, index) => (
                <option
                  key={attrValue}
                  className={`${isAvailable(attrValue) ? 'available' : 'not-available'}`}
                  value={attrValue}
                  id={props.attribute.name + index}
                  aria-disabled={isAvailable(attrValue) ? false : true}
                  disabled={isAvailable(attrValue) ? false : true}
                >
                  {`${attrValue.split('#double;').join('"')}`}

                  {showPricePoints && isAvailable(attrValue)
                    ? curPriceVals.map((price, j) => {
                        const zonosIsWorking = typeof zonos === 'object' ? true : false;
                        let cleanPrice = attrValue.replace('$', '');
                        if (price.attrVal === cleanPrice) {
                          try {
                            const minPrice = zonosIsWorking
                              ? zonos.currencyConvertAndFormat(price.minPrice)
                              : '$' + price.minPrice.toFixed(2);
                            const maxPrice = zonosIsWorking
                              ? zonos.currencyConvertAndFormat(price.maxPrice)
                              : '$' + price.maxPrice.toFixed(2);
                            const pricesMatch = maxPrice === minPrice;
                            const displayPrice = pricesMatch ? ' - ' + minPrice : ' - ' + minPrice + ' - ' + maxPrice;
                            return displayPrice;
                          } catch (e) {
                            console.log(e);
                          }
                        }
                      })
                    : ''}
                </option>
              ))}
            </select>
            {additionalSizes.length > 0 && props.attribute.name == 'Size' ? (
              <div id='addtlSizesContainer'>
                <span>Also Available In:</span>
                {additionalSizes.map((currentSize) => {
                  return (
                    <Link
                      to={{
                        pathname: `/p/${currentSize.productURL}?addtlSizes=true`,
                        state: { qv: true, additionalSize: true, addSizeAttribute: currentSize.additionalName },
                      }}
                      className='additionalSizeLink'
                      key={currentSize.productId}
                      replace={
                        props.contentData.productLayout === 'QuickViewDisplay' ||
                        (props.isQuickview !== undefined && props.isQuickview === true)
                          ? true
                          : false
                      }
                    >
                      {currentSize.additionalName}
                    </Link>
                  );
                })}
              </div>
            ) : (
              ''
            )}
          </>
        ) : (
          <>
            <span className='one-option'>
              {attrValues[0]}
              <input type='hidden' value={attrValues[0]} name='attrValue' />
            </span>
            {additionalSizes.length > 0 && props.attribute.name == 'Size' ? (
              <div id='addtlSizesContainer'>
                <span>Also Available In:</span>
                {additionalSizes.map((currentSize) => {
                  return (
                    <Link
                      to={{
                        pathname: `/p/${currentSize.productURL}?addtlSizes=true`,
                        state: { qv: true, additionalSize: true, addSizeAttribute: currentSize.additionalName },
                      }}
                      className='additionalSizeLink'
                      key={currentSize.productId}
                      replace={
                        props.contentData.productLayout === 'QuickViewDisplay' ||
                        (props.isQuickview !== undefined && props.isQuickview === true)
                          ? true
                          : false
                      }
                    >
                      {currentSize.additionalName}
                    </Link>
                  );
                })}
              </div>
            ) : (
              ''
            )}
          </>
        )}
      </div>
      <input type='hidden' value={props.attribute.name} name='attrName' />
    </>
  );
}
